import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardGuard } from '../guards/auth-guard.guard';
import { CanActivateGuard } from '../guards/can-activate.guard';
import { NotFoundComponent } from '../not-found/not-found.component';

const routes: Routes = [

  {
    path: 'login',
    loadChildren: () => import('src/app/authentication/authentication.module').then(m => m.AuthenticationModule),
    data: {
      title: 'Login'
    }
  },
  {
    path: 'ott-onboarding', loadChildren: () => import('src/app/ott-onboarding/ott-onboarding.module').then(m => m.OttOnboardingModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Provider Dashboard'
    }
  },
  {
    path: 'packages', loadChildren: () => import('src/app/packages-new/packages-new.module').then(m => m.PackagesNewModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Packages'
    }
  },
  {
    path: 'channels', loadChildren: () => import('src/app/channels/channels.module').then(m => m.ChannelsModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Channels'
    }
  },
  {
    path: 'channels-access', loadChildren: () => import('src/app/channels-access/channels-access.module').then(m => m.ChannelsAccessModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Channel Access'
    }
  },
  {
    path: 'categories', loadChildren: () => import('src/app/categories/categories.module').then(m => m.CategoriesModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Categories'
    }
  },
  {
    path: 'subscribers', loadChildren: () => import('src/app/users/users.module').then(m => m.UsersModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Users'
    }
  },
  {
    path: 'admin', loadChildren: () => import('src/app/admin/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Admin'
    }
  },
  {
    path: 'admin-groups', loadChildren: () => import('src/app/admin-groups/admin-groups.module').then(m => m.AdminGroupsModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Admin Groups'
    }
  },
  {
    path: 'dashboard', loadChildren: () => import('src/app/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Dashboard'
    }
  },
  {
    path: 'coupon-management', loadChildren: () => import('src/app/coupon-management/coupon-management.module').then(m => m.CouponManagementModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Coupons'
    }
  },
  {
    path: 'notifications', loadChildren: () => import('src/app/notifications/notifications.module').then(m => m.NotificationsModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Notifications'
    }
  },
  {
    path: 'franchise', loadChildren: () => import('src/app/franchise/franchise.module').then(m => m.FranchiseModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Franchise'
    }
  },
  {
    path: 'distributor', loadChildren: () => import('src/app/distributor/distributor.module').then(m => m.DistributorModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Distributor'
    }
  },
  {
    path: 'manager', loadChildren: () => import('src/app/account-manager/account-manager.module').then(m => m.AccountManagerModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Manager'
    }
  },
  {
    path: 'upload-banner', loadChildren: () => import('src/app/upload-banner/upload-banner.module').then(m => m.UploadBannerModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Upload-banner'
    }
  },
  {
    path: 'settings', loadChildren: () => import('src/app/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Settings'
    }
  },
  {
    path: 'ui-builder', loadChildren: () => import('src/app/ui-builder/ui-builder.module').then(m => m.UiBuilderModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'UI-Builder'
    }
  },
  {
    path: 'profile', loadChildren: () => import('src/app/profile/profile.module').then(m => m.ProfileModule),
    data: {
      title: 'Profile'
    }
  },
  {
    path: 'payment', loadChildren: () => import('src/app/payment/payment.module').then(m => m.PaymentModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Payment'
    }
  },
  {
    path: 'coupons-logs', loadChildren: () => import('src/app/coupons-logs/coupons-logs.module').then(m => m.CouponsLogsModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Coupons'
    }
  },
  {
    path: 'activity-logs', loadChildren: () => import('src/app/activity-logs/activity-logs.module').then(m => m.ActivityLogsModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Activity'
    }
  },
  {
    path: 'subscriber-logs', loadChildren: () => import('src/app/subscriber-logs/subscriber-logs.module').then(m => m.SubscriberLogsModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Subscriber'
    }
  },
  {
    path: 'wallet-logs', loadChildren: () => import('src/app/wallet-logs/wallet-logs.module').then(m => m.WalletLogsModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Wallet'
    }
  },
  {
    path: 'franchise-mapping', loadChildren: () => import('src/app/franchise-mapping/franchise-mapping.module').then(m => m.FranchiseMappingModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Franchise Mapping'
    }
  },
  {
    path: 'franchise-wise-Otts', loadChildren: () => import('src/app/franchise-ott/franchise-ott.module').then(m => m.FranchiseOttModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Franchise Wise Ott'
    }
  },
  {
    path: 'clients', loadChildren: () => import('src/app/clients/clients.module').then(m => m.ClientsModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Clients'
    }
  },
  {
    path: 'clientsMapping', loadChildren: () => import('src/app/clients-mapping/clients-mapping.module').then(m => m.ClientsMappingModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Clients-Mapping'
    }
  },
  {
    path: 'assign-provider',
    loadChildren: () => import('src/app/assign-provider/assign-provider.module').then(m => m.AssignProviderModule),
    canActivate: [AuthGuardGuard, CanActivateGuard],
    data: {
      title: 'Assign Provider'
    }
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent }
  // { path: '**', loadChildren: () => import('src/app/not-found/not-found.module').then(m => m.NotFoundModule) },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CoreRoutingModule { }
